import axios from "axios";
import { getMsalInstance } from "./msalInstance";
import { getMsalAccount } from "./msalAccount";
import { getBackendScopes } from "./authConfig";
import { isLikelyJwt } from "./tokenShape";

let interceptorId = null;

// On every outbound axios request, ask MSAL for a fresh backend access
// token via acquireTokenSilent and attach it as `Authorization: Bearer
// <token>`. MSAL caches the token internally and silently refreshes it
// when it's close to expiry, so we never carry a stale token through
// sessionStorage. If MSAL fails (interaction required, bad config, etc.)
// we strip Authorization rather than sending "Bearer null" — the
// backend's 401 then carries clean "no auth" semantics, and the existing
// AuthenticationFailureHandler triggers the re-auth redirect.
export const setupMsalAxiosInterceptor = () => {
  if (interceptorId !== null) return;

  interceptorId = axios.interceptors.request.use(
    async (config) => {
      const instance = getMsalInstance();
      const account = getMsalAccount();

      if (!instance || !account) return config;

      try {
        const response = await instance.acquireTokenSilent({
          scopes: getBackendScopes(),
          account,
        });
        const accessToken = response?.accessToken;
        if (isLikelyJwt(accessToken)) {
          config.headers = config.headers || {};
          config.headers.Authorization = `Bearer ${accessToken}`;
        } else if (config.headers) {
          delete config.headers.Authorization;
        }
      } catch {
        if (config.headers) delete config.headers.Authorization;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );
};
